import { I18n } from '@calendly/i18n'

import { setGetParams } from 'actions/core/navigation'

import { DISCOVER_TAB } from './tab-items'

export const getCategoryTo = (categoryKey) => ({
  pathname: '/integrations',
  search: `?category=${categoryKey}&tab=${DISCOVER_TAB}`
})

// i18n-tasks-use t('publisher.integrations.categories.admin_managed')
// i18n-tasks-use t('publisher.integrations.categories.all')
// i18n-tasks-use t('publisher.integrations.categories.analytics')
// i18n-tasks-use t('publisher.integrations.categories.api_and_connectors')
// i18n-tasks-use t('publisher.integrations.categories.calendars')
// i18n-tasks-use t('publisher.integrations.categories.email_messaging')
// i18n-tasks-use t('publisher.integrations.categories.embed_calendly')
// i18n-tasks-use t('publisher.integrations.categories.extensions_and_apps')
// i18n-tasks-use t('publisher.integrations.categories.integrations')
// i18n-tasks-use t('publisher.integrations.categories.marketing')
// i18n-tasks-use t('publisher.integrations.categories.most_popular')
// i18n-tasks-use t('publisher.integrations.categories.payments')
// i18n-tasks-use t('publisher.integrations.categories.sales_and_crm')
// i18n-tasks-use t('publisher.integrations.categories.security_and_compliance')
// i18n-tasks-use t('publisher.integrations.categories.video_conferencing')
export const getCategoryName = (categoryKey) => (
  I18n.t(`publisher.integrations.categories.${categoryKey}`)
)

export const integrationName = (item) => (
  // i18n-tasks-use t('publisher.integrations.names.#{key}')
  I18n.t(`publisher.integrations.names.${item.keyOverride || item.key}`)
)

export const openIntegrationsTab = (tab) => (dispatch, _) => {
  dispatch(setGetParams({ tab }))
}

export const openCategory = (category) => (dispatch, _) => {
  dispatch(setGetParams({ category }))
}
